module.exports = __webpack_public_path__ + "img/photo3_1.5253dd92.jpg";